export default __webpack_public_path__ + "static/media/trampapo_01-10.c56ef415.png";